import clsx from "clsx"
import { useState } from "react"

import { faIcon } from "@utils/faIcon"

import { Badge, Icon } from "@atoms/index"

import ListItem from "@molecules/ListItem/ListItem"
import ListItemContent from "@molecules/ListItem/ListItemContent/ListItemContent"

import { formatModifierAdjustment } from "@pages/Settings/SettingsCatalogs/SettingsCatalogsItemDetails/SettingsCatalogsItemDetails.utils"

import styles from "./ModifierGroupRow.module.scss"
import { ModifierGroupRowProps } from "./ModifierGroupRow.types"

export default function ModifierGroupRow(props: ModifierGroupRowProps) {
    const { group, currencyCode, languageCode } = props

    const [isExpanded, setIsExpanded] = useState(false)

    const modifierCount = group.modifiers.length
    const modifierCountLabel = `${modifierCount} ${modifierCount === 1 ? "option" : "options"}`

    return (
        <div>
            <ListItem.Root
                isClickable={true}
                onClick={() => setIsExpanded((previousIsExpanded) => !previousIsExpanded)}
                aria-expanded={isExpanded}
            >
                <ListItem.AvatarAndContent
                    content={
                        <ListItemContent
                            leftLabel={
                                <ListItem.Label
                                    label={group.name}
                                    suffixSlot={
                                        group.is_required ? (
                                            <Badge size="sm" showTooltip={false}>
                                                Required
                                            </Badge>
                                        ) : undefined
                                    }
                                />
                            }
                            rightCaption={<ListItem.Caption caption={modifierCountLabel} />}
                        />
                    }
                />
                <ListItem.Actions>
                    <Icon
                        size={14}
                        icon={faIcon({ name: "angle-right", style: "regular" })}
                        container="fixedHeight"
                        className={clsx(styles.chevron, { [styles.chevronExpanded]: isExpanded })}
                    />
                </ListItem.Actions>
            </ListItem.Root>
            {isExpanded && (
                <ul className={styles.modifierList}>
                    {group.modifiers.map((modifier) => (
                        <li key={modifier.external_id}>
                            <Badge size="sm" showTooltip={false}>
                                {modifier.name}
                                {formatModifierAdjustment(modifier, currencyCode, languageCode)}
                            </Badge>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}
